<template>
    <div>
        <modal :show.sync="show_modal" :hide-footer="true">
            <div v-if="approval" style="min-width: 500px !important;">
                <b-table-simple responsive bordered>
                    <b-tbody>
                        <b-tr>
                            <b-th class="bg-dark text-white py-2" width="150px">Lead ID</b-th>
                            <b-td class="bg-white py-2">{{ approval.appr_req_value.lead_id }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="bg-dark text-white py-2" width="150px">Lead Contact No.</b-th>
                            <b-td class="bg-white py-2">{{ approval.appr_req_value.contact_no }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="bg-dark text-white py-2" width="150px">Lead Email</b-th>
                            <b-td class="bg-white py-2">{{ approval.appr_req_value.email }}</b-td>
                        </b-tr>
                        <b-tr>
                            <b-th class="bg-dark text-white py-2" width="150px">Lead Income</b-th>
                            <b-td class="bg-white py-2">{{ approval.appr_req_value.income | moneyFormatter }}</b-td>                       
                        </b-tr>
                        <b-tr>
                            <b-th class="bg-dark text-white py-2" width="150px">Lead Details</b-th>
                            <b-td class="bg-white py-2">
                                <a href="javascript:void(0)" @click="$emit('preview-vps-value', approval.approval_type)" class="text-primary"><i class="fa fa-eye"></i></a>
                            </b-td> 
                        </b-tr>
                    </b-tbody>
                </b-table-simple>
                <div v-if="!is_view_mode">
                    <div class="my-4">
                        <b-form-textarea
                            id="textarea"
                            v-model="remark"
                            placeholder="Add a remark"
                            rows="3"
                            max-rows="6"
                        ></b-form-textarea>
                    </div>
                    <div class="d-flex justify-content-between">
                        <el-button class="bg-danger py-2 px-3 text-white" 
                        :loading="is_loading_review"
                        @click="submitReview(approval.next_approval_reviewers, 0)"
                        ><i class="fa fa-times mr-1"></i>Reject
                        </el-button>
                        <el-button class="bg-success py-2 px-3 text-white" 
                            :loading="is_loading_review"
                            @click="submitReview(approval.next_approval_reviewers, 1)"
                            ><i class="fa fa-check mr-1"></i>Approve
                        </el-button>
                    </div>
                </div>
            </div>
        </modal>  
    </div>
</template>
<script>
    import { Button } from 'element-ui'
    import { useAuthStore } from '@/stores/authStore'
    import { mapState } from 'pinia'
    import {
    notifyFunctionMixin,
    axios,
    services,
    getHeader,
    debounce,
    swal
} from '@/assets/js/httpImports.js'

    export default {
        props: ['approval'],
        mixins: [notifyFunctionMixin],
        components: {
            [Button.name]: Button,
        },
        data() {
            return {
                is_loading_review: false,
                show_modal: false,
                remark: '',
                is_view_mode: false,
            }
        },
        methods: {
            toggleView(is_view_mode = null) {
                if(is_view_mode !== null){
                    this.is_view_mode = is_view_mode
                }
                this.show_modal = !this.show_modal;
            },
            submitReview(next_reviewers, val){
                const reviewer = next_reviewers.find((item) => item.appr_rev_user_id === this.auth_user.id)
                if(!reviewer){
                    return
                }
                this.is_loading_review = true
                let data = {
                    'appr_rev_remark': this.remark,
                    'appr_rev_status': val
                }
                axios.put(services.approval + 'approval_reviewers/' + reviewer.appr_rev_id, data, {headers: getHeader()})
                    .then(res => {
                        this.remark = ''
                        this.is_loading_review = false
                        this.notifySuccess('<b>Approval: - Successfully Reviewed.')
                        this.$emit('refresh-approval')
                        this.show_modal = false
                    })
                    .catch(e=>{
                        this.is_loading_review = false
                        this.errorFunction(e)
                    })
            }
        },
        computed:{
            ...mapState(useAuthStore, ['auth_user'])
        },
    }
</script>